<template>
  <nav aria-label="page-navigation" class="pagination">
    <div class="input-group pagination-controls">
      <button class="page-link mr-2" :disabled="currentPage == 1" @click="changeToFirstPage">
        <i class="fas fa-step-backward"></i>
      </button>
      <button class="page-link" :disabled="currentPage == 1" @click="changeToPrevPage">
        <i class="fas fa-chevron-left"></i>
      </button>
      <span
        v-show="!enterPageMode"
        @click="setToPageMode"
        class="page-link mx-1"
        style="width: 102px; text-align: center"
        >{{ currentPage }} / {{ totalPages }}</span
      >
      <span v-show="enterPageMode" class="mx-1 count" style="width: 102px; text-align: center">
        <input
          id="go-to-page"
          ref="enterPageNumber"
          style="width: 102px; max-width: 102px"
          class="form-control"
          type="num"
          @keydown.enter="selectPageNumber($event)"
          @keydown.esc="enterPageMode = false"
        />
      </span>

      <button class="page-link" :disabled="currentPage >= totalPages" @click="changeToNextPage">
        <i class="fas fa-chevron-right"></i>
      </button>
      <button
        class="page-link ml-2"
        :disabled="currentPage >= totalPages"
        @click="changeToLastPage"
      >
        <i class="fas fa-step-forward"></i>
      </button>
    </div>
  </nav>
</template>

<script>
export default {
  props: ['currentPage', 'totalPages', 'listLenght'],
  data: () => ({ enterPageMode: false }),
  methods: {
    setToPageMode() {
      this.enterPageMode = !this.enterPageMode;

      this.$nextTick(() => this.$refs.enterPageNumber.focus());
    },
    changeToNextPage() {
      this.$emit('nextPage');
    },
    changeToPrevPage() {
      this.$emit('prevPage');
    },
    changeToLastPage() {
      this.$emit('lastPage', this.totalPages);
    },
    changeToFirstPage() {
      this.$emit('firstPage');
    },
    selectPageNumber(e) {
      this.$emit('selectPageByNumber', e.target.value);
      this.enterPageMode = false;
    },
    handleClickOutside(e) {
      if (!this.$el.contains(e.target)) {
        this.enterPageMode = false;
      }
    },
    handlerKeyup(e) {
      this.$emit('keyup', e);
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    window.addEventListener('keyup', this.handlerKeyup);
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside);
    window.removeEventListener('keyup', this.handlerKeyup);
  },
};
</script>
